import i18n from '@/i18n'
export const columns = [
    {
        columnId: 1,
        name: i18n.t('defe.defe67'),
        key: "handle",
        width: "120",
    },
    {
        columnId: 2,
        name: i18n.t('defe.defe68'),
        key: "handleWay",
        minWidth:'200'
    },
    {
        columnId: 3,
        name: i18n.t('defe.defe69'),
        key: "badNo",
    },
    {
        columnId: 4,
        name: i18n.t('defe.defe70'),
        key: "createTime",
        width: "100",
    },
    {
        columnId: 5,
        name:  i18n.t('orderList.orderList2'),
        key: "no",
    },
    {
        columnId: 6,
        name:i18n.t('defe.defe71'),
        key: "count",
    },
    {
        columnId: 7,
        name: i18n.t('defe.defe72'),
        key: "pictureUrl1",
        minWidth: 100,
    },
    {
        columnId: 10,
        name: i18n.t('defe.defe73'),
        key: "badPicture",
        minWidth: 240,
    },
    {
        columnId: 14,
        name: i18n.t('defe.defe74'),
        key: "badSituation",
    },
    {
        columnId: 15,
        name: i18n.t('defe.defe99'),
        key: "badCount",
    },
    {
        columnId: 15,
        name: i18n.t('defe.defe75'),
        key: "badDesc",
    },
    {
        columnId: 16,
        name: i18n.t('defe.defe76'),
        key: "handleDesc",
        width: "170",
    },
    {
        columnId: 17,
        name: i18n.t('defe.defe77'),
        key: "handleStatus",
    },
    {
        columnId: 18,
        name:i18n.t('defe.defe78'),
        key: "handleTime",
    },
    {
        columnId: 19,
        name: i18n.t('defe.defe79'),
        key: "returnWaybillNo",
    },
    {
        columnId: 20,
        name: i18n.t('defe.defe80'),
        key: "waybillNumber",
    },
    {
        columnId: 21,
        name: i18n.t('defe.defe81'),
        key: "returnAddress",
    },
    {
        columnId: 22,
        name: i18n.t('OrderBill.OrderBill21'),
        key: "problemVideo",
    }
];
